// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import consultationSignatoryEntity from './entities/consultation-signatory.json';
import consultationSignatoryMenu from '../pages/consultation-signatory/menu.json';
import consultationSignatoryFullForm from '../pages/consultation-signatory/forms/full.json';
import consultationSignatoryContextForm from '../pages/consultation-signatory/forms/context.json';
import consultationSignatoryMiniForm from '../pages/consultation-signatory/forms/mini.json';
import consultationSignatoryLookupForm from '../pages/consultation-signatory/forms/lookup.json';
import consultationSignatoryTableView from '../pages/consultation-signatory/views/table.json';
import consultationSignatoryCardsView from '../pages/consultation-signatory/views/cards.json';
import consultationSignatoryDashboardView from '../pages/consultation-signatory/views/dashboard.json';

/** Тип запису «Підписант» зі сторінками пакета: меню, форми та подання з pages/consultation-signatory/. */
export const consultationSignatoryDefinition: IRecordTypeDefinition = {
  ...consultationSignatoryEntity,
  views: assembleViewSet({
      table: consultationSignatoryTableView,
      cards: consultationSignatoryCardsView,
      dashboard: consultationSignatoryDashboardView,
  }),
  form: consultationSignatoryFullForm,
  forms: { full: consultationSignatoryFullForm, context: consultationSignatoryContextForm, mini: consultationSignatoryMiniForm, lookup: consultationSignatoryLookupForm },
  menu: consultationSignatoryMenu,
} as IRecordTypeDefinition;
